import React, {ReactElement, ReactNode} from 'react';
import {Locale, useLocale} from './RootProvider/LocaleContext';

export interface Props {
  children: ReactNode;
  locales: Locale[];
  FallbackComponent?: ReactElement;
}

const RenderOnLocales = ({children, locales, FallbackComponent}: Props): ReactElement | null => {
  const currentLocale = useLocale();
  const isMatchingLocale = locales.some((renderLocale) => renderLocale === currentLocale);

  if (locales.length === 0 || isMatchingLocale) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  if (FallbackComponent) {
    return FallbackComponent;
  }

  return null;
};

export const RENDER_ON_LOCALES_DISPLAY_NAME = 'RenderOnLocales';
RenderOnLocales.displayName = RENDER_ON_LOCALES_DISPLAY_NAME;

export default RenderOnLocales;
